<hbo-datatable-smart *ngIf="gazeMaps$ | async as gazeMaps"
  [typeData]="'gazeMaps'"  
  [columns]="getColumns(gazeMaps)"
  [entities_filter]="entities_filter"
  [types_filter]="types_filter"
  [items]="gazeMaps" (reload)="searchGazeMaps($event)"
  [prevDynamoKey]="prevDynamoKey"
  [lastDynamoKey]="lastDynamoKey"
  [pages]="dynamoPaginationService.currentGazemapsPaginationValue"
  [showDateFilter]="true"
  [paginationType]="'dynamo'"
>
  <tbody class="table-group-divider accordion" id="accordionGazeMap">
    <ng-container *ngFor="let gazeMap of gazeMaps.data">
      <tr>
        <th scope="row"><div style="height: 32.5px;"></div></th>
        <td>{{ gazeMap.testId }}</td>
        <td *ngIf="user.roleId == 1 || gazeMaps.shortTestID">{{ gazeMap.alias }}</td>
        <td>{{ getAplicacionNameTranslated(gazeMap.aplicacion_name) | translate }}</td>
        <td>{{ gazeMap.date | date:'yyyy/MM/dd HH:mm' }}</td>
        <td>{{ gazeMap.created_at_non_utc | date:'yyyy/MM/dd HH:mm' }}</td>
        <td *ngIf="user.role!.id != 4">{{ gazeMap.created_at | date:'yyyy/MM/dd HH:mm' }}</td>        
        <td *ngIf="user.role!.id != 4">{{ getClientName(gazeMap.idCliente) }}</td>
        <td>{{ gazeMap.referencia !== 'empty' && gazeMap.referencia !== 'null'? gazeMap.referencia : ''}}</td>
        <td><a [routerLink]="'/gaze-maps/' + gazeMap.testId" (click)="persistanceFilters(gazeMap.idCliente)" class="link-dark link-underline-opacity-0">{{ 'COMMON.VIEW_RESULT' | translate }} <i class="bi bi-chevron-right"></i></a></td>
      </tr>
    </ng-container>
    <tr *ngIf="!gazeMaps.data.length">
      <td colspan="8" class="text-center">{{ 'COMMON.NO_RESULTS' | translate }}</td>
    </tr>
  </tbody>
</hbo-datatable-smart>